import { Alohomora as UniversalLogin } from '@vitalsource/alohomorajs'
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ROLES } from '@/constants/roles'
import { isUSRegionSelector } from '@/selectors'
import { DEV_ENVIRONMENTS } from '@/utils/constants'

const RAILS_ENV = process.env.RAILS_ENV

const UniversalLoginProps = {
  appName: 'store',
  authHost: window.location.host,
  authProtocol: window.location.protocol,
  listener: 'login',
  method: 'jwt',
  mode: 'popup',
  testId: 'universal-login-button',
}
const EDUCATORS = '/educators'

const UniversalLoginModal = ({
  buttonText,
  className = 'vst-btn--large-full-width vst-btn--orange',
  url = window.location.href
}) => {
  const locale = useSelector(state => state.currentLocale.locale)
  const isDev = DEV_ENVIRONMENTS.includes(RAILS_ENV)
  const isUSRegion = useSelector(isUSRegionSelector)
  const isEducatorPath = new RegExp(EDUCATORS, 'i').test(window.location.href)
  const role = isEducatorPath ? ROLES.instructor : ROLES.learner

  const universalLogin = new UniversalLogin({
    auth_host: UniversalLoginProps.authHost,
    auth_protocol: UniversalLoginProps.authProtocol,
    auto_open: false,
    brand: window.location.hostname,
    context: UniversalLoginProps.appName,
    dev: isDev,
    locale: locale,
    marketing: isUSRegion,
    method: UniversalLoginProps.method,
    redirect_uri: url,
    role: role,
    ux_mode: UniversalLoginProps.mode
  })

  const listenerEvent = event => {
    window.location = event.authenticatedRedirect
    universalLogin.destroy()
  }

  const handleOnClick = () => universalLogin.open()

  useEffect(() => {
    universalLogin.removeListener(UniversalLoginProps.listener, listenerEvent)
    universalLogin.addListener(UniversalLoginProps.listener, listenerEvent)
  }, [])

  return (
    <button
      className={className}
      data-testid={UniversalLoginProps.testId}
      onClick={handleOnClick}
    >
      {buttonText}
    </button>
  )
}

UniversalLoginModal.propTypes = {
  buttonText: PropTypes.string.isRequired,
  className: PropTypes.string,
  url: PropTypes.string
}

export default UniversalLoginModal
